import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

Vue.prototype.$locale = {
  change(lang) {
    // Forzar inglés siempre
    i18n.locale = "en";
    localStorage.setItem("lang", "en");
    console.log("i18n lang", "en");
    console.log("i18n lang storage", localStorage.getItem("lang"));
  },
  current() {
    return i18n.locale;
  },
};

// Función para normalizar el idioma a inglés
function getDefaultLocale() {
  const storedLang = localStorage.getItem("lang");
  // Si hay un idioma guardado que no sea inglés, limpiarlo y usar inglés
  if (storedLang && !storedLang.startsWith("en")) {
    localStorage.setItem("lang", "en");
    return "en";
  }
  // Si hay un idioma guardado en inglés, usarlo
  if (storedLang && storedLang.startsWith("en")) {
    return storedLang.includes("-") ? "en-US" : "en";
  }
  // Siempre usar inglés por defecto
  localStorage.setItem("lang", "en");
  return "en";
}

const i18n = new VueI18n({
  locale: getDefaultLocale(),
  silentFallbackWarn: true,
  fallbackLocale: "en",
  messages: loadLocaleMessages(),
});

export default i18n;
